import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import React from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { CheckActionPermission } from "Actions/commonAction";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { FEATUREKEYS } from "Constants/Featurekeys";

import moment from "moment";
import { bindActionCreators } from "redux";
import { Doughnut } from "react-chartjs-2";
import PageHeader from "Component/Headers/pageHeader";
import CallOutNew from "Component/Headers/callOutNew";
import headersList from "../../../../../../Constants/headersList";
import { instance } from "../../../../../../Actions/AxiosInstance";
import attachmentIcon from "../../../../../../Assets/Svg/attachment.svg";
import expensePassbookIcon from "../../../../../../Assets/Svg/expense-passbook.svg";
import expenseIcon from "../../../../../../Assets/Icons/Expense/expense-16px.svg";
import walletIcon from "../../../../../../Assets/Icons/Wallet/wallet-16px.svg";
import policy from "../../../../../../Assets/Icons/Policy/policy-16px.svg";
import expensenodata from "../../../../../../Assets/Svg/expensenodata.svg";
import AdvancedRequest from "./AdvancedRequest";
import ClaimRequest from "./ClaimRequest";
import {
  getEJ2CalenderDateFormat,
  getFormattedDate,
} from "../../../../../../Utils";
import { setDynamicForm } from "../../../../../../Actions/commonAction";
import "./index.css";
import DefaultComp from "../../../../../../Component/DefaultComp/Defaultstatecomp";
import emptylist from "../../../../../../Assets/Svg/no-expensepolicy.svg";
import { DatePickerComponent } from "../../../../../../Component/Custom";

const getValue = (x, y) => {
  if (x < y) {
    return 100;
  }
  const a = Math.floor((y / x) * 100);
  if (a == 0) {
    return 1;
  }
  return parseInt(a);
};

const date = new Date();
const year = parseInt(date.getUTCFullYear());
const month = parseInt(date.getUTCMonth() + 1);

class ExpenseDahsboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      drawerStatus: false,
      reqType: "",
      claimPolicy: null,
      dataReceived: false,
      postdata: {
        expensepolicyid: null,
        expenserequesttypeid: 1,
        comment: "",
        sendersourceid: 1,
        totalamount: null,
        expenserequestdetail: [],
      },
      copydata: {
        expensepolicyid: null,
        expenserequesttypeid: 1,
        comment: "",
        sendersourceid: 1,
        totalamount: null,
        expenserequestdetail: [],
      },
      balance: 0,
      employeeid: null,
      SelectedEmpData: null,
      fromdate: `${year}-${month}-01`,
      spendlimit: "",
      compensatedamount: "",
      pendingclaimrequest: "",
      empList1: [],
      month,
      year,
      claimerror: false,
      expensebook: [],
      chartdataLabels: [],
      chartdataValue: [],
      noDataAvailable: false,
      isFromModule: false,
      options: null,
    };

    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.getClaimPolicy = this.getClaimPolicy.bind(this);
    this.SearchEmployee = this.SearchEmployee.bind(this);
    this.UpdateSelectedEmpId = this.UpdateSelectedEmpId.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("employeeExpense");
    if (isTrue) {
      this.setState({ permissions }, () => {
        const isFromModule = this.props.match.path == "/app/pay/expense";
        this.setState({
          isFromModule,
        });
        if (
          isFromModule &&
          this.props.AuthenticationAction.login.masterprofileid != 9
        ) {
          this.GetEmployeeDetails();
        }
        if (!isFromModule) {
          this.getClaimPolicy();
        }
        this.getWallet();
        this.getDashboard();
        this.getChart();
        this.getDoj();
        this.getExpenseList();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillReceiveProps(props) {
    console.log("props dash expense: ", props);
  }

  getDoj() {
    const id = this.props.SelectedEmpData
      ? this.state.SelectedEmpData.displayvalue
      : this.props.AuthenticationAction.login.employeeid;
    instance.get(`leaves/initleaveapply/${id}`).then((dojdata) => {
      this.setState({
        doj: dojdata.data.result[0].doj,
      });
    });
  }

  getWallet() {
    const id =
      this.state.employeeid || this.props.AuthenticationAction.login.employeeid;
    instance
      .get(`expense/walletamount/${id}`)
      .then((result) => {
        this.setState({
          balance:
            (result.data.result[0] && result.data.result[0].balance) || 0,
        });
      })
      .catch((error) => {
        const msg =
          error && error.response && error.response.data.error.message;
        this.props.enqueueSnackbar(msg, {
          variant: "error",
        });
      });
  }

  getDashboard() {
    const id =
      this.state.employeeid || this.props.AuthenticationAction.login.employeeid;
    instance
      .get(`expense/expensedashboard/count/${id}`)
      .then((result) => {
        const spendlimit =
          result.data.result[0] && result.data.result[0].spendlimit;
        const compensatedamount =
          result.data.result[0] && result.data.result[0].compensatedamount;
        const pendingclaimrequest =
          result.data.result[0] && result.data.result[0].pendingclaimrequest;
        this.setState({
          spendlimit,
          compensatedamount,
          pendingclaimrequest,
          dataReceived: true,
          noDataAvailable: false,
        });
      })
      .catch(() => {
        this.setState({ noDataAvailable: true, dataReceived: true });
      });
  }

  getChart() {
    const id =
      this.state.employeeid || this.props.AuthenticationAction.login.employeeid;
    const data = {
      employeeid: id,
      month: this.state.month,
      year: this.state.year,
    };
    instance
      .post(`expense/expensedashboard/expensebook`, data)
      .then((result) => {
        this.setState({
          chartdataValue:
            result.data.result.map((d) => d.compensatamount) || [],
          chartdataLabels:
            result.data.result.map((d) => d.subcategoryname) || [],
        });
      })
      .catch((error) => {
        const msg =
          error && error.response && error.response.data.error.message;
        this.props.enqueueSnackbar(msg, {
          variant: "error",
        });
      });
  }

  getExpenseList() {
    const id =
      this.state.employeeid || this.props.AuthenticationAction.login.employeeid;
    const data = {
      employeeid: id,
      month: this.state.month,
      year: this.state.year,
    };
    instance
      .post(`expense/expensedashboard/expensepassbook`, data)
      .then((result) => {
        this.setState({
          expensebook: result.data.result,
        });
      })
      .catch((error) => {
        const msg =
          error && error.response && error.response.data.error.message;
        this.props.enqueueSnackbar(msg, {
          variant: "error",
        });
      });
  }

  getClaimPolicy() {
    const { SelectedEmpData } = this.state;
    instance
      .post(`requestcenter/initexpenserequest`, {
        currencyconversionlogid: null,
        conversionrate: null,
        employeeid: SelectedEmpData ? SelectedEmpData.displayvalue : null,
      })
      .then((result) => {
        const { postdata } = this.state;
        postdata.expensepolicyid = result.data.result[0].expensepolicyid;
        const { copydata } = this.state;
        postdata.expensepolicyid = result.data.result[0].expensepolicyid;
        this.setState({
          claimPolicy: result.data.result[0],
          dataReceived: true,
          copydata,
          postdata,
          claimerror: false,
        });
      })
      .catch((error) => {
        this.setState({
          dataReceived: false,
          claimerror: true,
        });
        const msg =
          error && error.response && error.response.data.error.message;
        // this.props.enqueueSnackbar(msg, {
        //   variant: "error",
        // });
      });
  }

  UpdateDate(name, e) {
    console.log("e: ", e);
    if (e.value) {
      const month1 = parseInt(moment(e.value).format("MM"));
      const year1 = parseInt(moment(e.value).format("YYYY"));
      this.setState(
        {
          [name]: moment(e.value).format("YYYY-MM-DD"),
          month: month1,
          year: year1,
        },
        () => {
          this.getChart();
          this.getExpenseList();
          this.getDashboard();
          this.getWallet();
        },
      );
    } else {
      this.setState(
        {
          [name]: `${year}-${month}-01`,
          month,
          year,
        },
        () => {
          this.getDashboard();
          this.getWallet();
          this.getChart();
          this.getExpenseList();
        },
      );
    }
  }

  GetEmployeeDetails() {
    const data = {
      featurekey: "employeeExpense",
      workflowfortypeid: 5,
    };
    instance
      .post(`attendance/approverreportee`, data)
      .then((result) => {
        const arrAllEmp = result.data.result;
        const opt = [];
        opt.push({
          label: "Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 1,
          ),
        });

        opt.push({
          label: "In-Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 3,
          ),
        });

        this.setState({ empList1: opt });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  SearchEmployee(search) {
    if (search.length < 1) return;
    if (
      (!this.state.prevSearch || this.state.prevSearch != search) &&
      search.length >= 1
    ) {
      const URL = `/subscription/employeelist`;
      const data = {
        searchfor: search,
        statusid: null,
        featurekey: "attendanceLogs",
      };
      instance
        .post(URL, data)
        .then((result) => {
          const arrAllEmp = result.data.result;
          const opt = [];
          opt.push({
            label: "Active",
            options: arrAllEmp.filter(
              (employee) => employee.employeestatusid == 1,
            ),
          });

          opt.push({
            label: "In-Active",
            options: arrAllEmp.filter(
              (employee) => employee.employeestatusid == 3,
            ),
          });

          this.setState({ empList: opt });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  UpdateSelectedEmpId(selectedItem) {
    if (selectedItem) {
      this.setState(
        {
          employeeid: selectedItem.displayvalue,
          SelectedEmpData: selectedItem,
        },
        () => {
          if (selectedItem && selectedItem.displayvalue) {
            this.getDoj();
            this.getWallet();
            this.getDashboard();
            this.getExpenseList();
            this.getChart();
            this.getClaimPolicy();
          }
        },
      );
    } else {
      this.setState({
        claimerror: false,

        employeeid: null,
        SelectedEmpData: selectedItem,
      });
    }
  }

  toggleDrawer({ drawerStatus, reqType, onsave }) {
    if (this.state.reqType == "claim" && !onsave) {
      this.props.enqueueSnackbar(
        "You will loss this data, Are you sure you want to cancel this?",
        {
          variant: "warning",
          action: [
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() =>
                this.setState(
                  {
                    drawerStatus,
                    reqType,
                  },
                  () => {
                    this.props.closeSnackbar();
                  },
                )
              }
            >
              Yes
            </Button>,
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => this.props.closeSnackbar()}
            >
              No
            </Button>,
          ],
        },
      );
    } else {
      const { postdata, claimPolicy } = this.state;
      postdata.expensepolicyid = claimPolicy && claimPolicy.expensepolicyid;
      const { copydata } = this.state;
      postdata.expensepolicyid = claimPolicy && claimPolicy.expensepolicyid;
      postdata.expenserequestdetail = [];
      copydata.expenserequestdetail = [];
      this.props.setDynamicForm({ forms: [] });
      this.setState(
        {
          drawerStatus,
          reqType,
          dataReceived: true,
          postdata,
          copydata,
        },
        () => {
          this.getWallet();
        },
      );
    }
  }

  render() {
    const {
      reqType,
      dataReceived,
      fromdate,
      noDataAvailable,
      isFromModule,
      employeeid,
      claimPolicy,
      claimerror,
      SelectedEmpData,
    } = this.state;
    const selected = fromdate && moment(fromdate).format("YYYY-MM-DD");

    const selectedmonth = fromdate && moment(fromdate).format("MM");
    const today = moment(new Date()).format("YYYY-MM-DD");

    let dateallow = true;
    if (selected && parseInt(selectedmonth) != month) {
      dateallow = true;
    } else {
      dateallow = false;
    }
    const c = dateallow && selected < today;
    const getDisplay = () => {
      if (dataReceived) {
        if (noDataAvailable) {
          return false;
        } else if (!noDataAvailable) {
          if (isFromModule) {
            if (this.state.SelectedEmpData) {
              return true;
            }
            return false;
          }
          return true;
        }
      } else {
        return false;
      }
    };
    const migrateexpense = this.props.AuthenticationAction.login.migration.find(
      (x) => x.moduletypeid == 3,
    );

    const expenseRequest = this.props.AuthenticationAction.login.features.find(
      (feature) => feature.featureid == FEATUREKEYS.expenseRequest,
    );

    const advanceRequest = this.props.AuthenticationAction.login.features.find(
      (feature) => feature.featureid == FEATUREKEYS.advanceRequest,
    );

    return (
      <div
        className={
          isFromModule
            ? "content-outer-wrapper-with-tab"
            : "content-outer-wrapper"
        }
      >
        {isFromModule ? (
          <Helmet>
            <title>{headersList.Expense.StartExpense.header}</title>
          </Helmet>
        ) : (
          <Helmet>
            <title>{headersList.Expense.Expense.header}</title>
          </Helmet>
        )}
        {(isFromModule && !this.props.showexpense) ||
        (!isFromModule && this.state.permissiondenied) ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            <Grid container>
              <Grid item xs={12} md={12} sm={12}>
                <PageHeader
                  header={isFromModule ? "Employee expense data" : "My expense"}
                />
                <div className="floatleft margin-right-16">
                  {this.props.AuthenticationAction.login.masterprofileid == 9 &&
                    this.state.isFromModule && (
                      <span>
                        <Select
                          className="selectsearch inlindClass width250"
                          onChange={this.UpdateSelectedEmpId}
                          onInputChange={this.SearchEmployee}
                          options={this.state.empList}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          value={this.state.SelectedEmpData}
                          placeholder="Search Employee"
                          isClearable={true}
                        />
                      </span>
                    )}
                  {this.props.AuthenticationAction.login.masterprofileid != 9 &&
                    this.state.isFromModule && (
                      <span>
                        <Select
                          className="selectsearch inlindClass width250"
                          onChange={this.UpdateSelectedEmpId.bind(this)}
                          options={this.state.empList1}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          value={this.state.SelectedEmpData}
                          placeholder="Select Employee"
                        />
                      </span>
                    )}
                </div>
                {isFromModule && (
                  <div className="floatleft width75">
                    {this.state.SelectedEmpData ? (
                      <CallOutNew
                        classnames="bg-light-blue width100"
                        header="Expense claims of the selected employee is displayed below."
                        emoji="🔍 👩🏻‍💼 💸"
                        textcolor="#1e8ced"
                      />
                    ) : (
                      <CallOutNew
                        classnames="bg-light-blue width100"
                        header="Search and select the employee whose expense claims you wish to see."
                        emoji="🔍 👩🏻‍💼 💸"
                        textcolor="#1e8ced"
                      />
                    )}
                  </div>
                )}
                <div className="clear-left"></div>
              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                sm={12}
                className="margin-bottom-16"
                style={{ marginTop: isFromModule ? "16px" : "-65px" }}
              >
                <div className="floatright">
                  {!isFromModule && migrateexpense && migrateexpense.isenable && (
                    <div
                      style={{
                        float: "left",
                        width: 240,
                        marginTop: 8,
                        color: "#057cff",
                        fontWeight: 400,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        window.open(migrateexpense.oldurl);
                      }}
                    >
                      View expense in sumHR 2.0
                    </div>
                  )}
                  {isFromModule
                    ? SelectedEmpData &&
                      !claimerror && (
                        <span className="margin-right-8 inlindClass">
                          <DatePickerComponent
                            start="Decade"
                            depth="Year"
                            className="width100"
                            max={new Date()}
                            format={getEJ2CalenderDateFormat("mmm,YYYY")}
                            value={this.state.fromdate}
                            ref={(date1) => (this.dateObj1 = date1)}
                            allowEdit={false}
                            change={(e) => this.UpdateDate("fromdate", e)}
                            placeholder="From"
                            width={"200px"}
                          />
                        </span>
                      )
                    : !claimerror && (
                        <span className="margin-right-8 inlindClass">
                          <DatePickerComponent
                            start="Decade"
                            depth="Year"
                            className="width100"
                            max={new Date()}
                            format={getEJ2CalenderDateFormat("mmm,YYYY")}
                            value={this.state.fromdate}
                            ref={(date1) => (this.dateObj1 = date1)}
                            allowEdit={false}
                            change={(e) => this.UpdateDate("fromdate", e)}
                            placeholder="From"
                            width={"200px"}
                          />
                        </span>
                      )}
                  {isFromModule
                    ? SelectedEmpData &&
                      !claimerror && (
                        <span
                          style={{
                            background: "#edf5fd",
                            borderRadius: 4,
                            padding: "10px 16px",
                          }}
                        >
                          <span className="margin-right-8 vertical-middle">
                            <img src={walletIcon} />
                          </span>
                          <span
                            style={{ color: "#057cff", fontWeight: "bold" }}
                          >
                            {
                              this.props.SubscriptionInfo.SubscriptionData
                                .currencycode
                            }{" "}
                            {this.state.balance}
                          </span>
                        </span>
                      )
                    : !claimerror && (
                        <span
                          style={{
                            background: "#edf5fd",
                            borderRadius: 4,
                            padding: "10px 16px",
                          }}
                        >
                          <span className="margin-right-8 vertical-middle">
                            <img src={walletIcon} />
                          </span>
                          <span
                            style={{ color: "#057cff", fontWeight: "bold" }}
                          >
                            {
                              this.props.SubscriptionInfo.SubscriptionData
                                .currencycode
                            }{" "}
                            {this.state.balance}
                          </span>
                        </span>
                      )}
                </div>
              </Grid>

              {getDisplay() && (
                <Grid item xs={12} md={12} sm={12}>
                  <Grid container>
                    <Grid item xs={12} md={8} sm={10}>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          sm={10}
                          className="padding-right-24 padding-bottom-24"
                        >
                          <div className="margin-bottom-8">
                            <span className="icon-with-label">
                              <img src={policy} alt="" height="16" />
                            </span>
                            <span className="icon-label">Wallet</span>
                          </div>
                          <Paper
                            className="padding16"
                            style={{
                              height: 80,
                              background:
                                dateallow && selected < today && "#f7f8f8",
                            }}
                          >
                            <div className="floatleft margin-top-20">
                              <p className="input-label">Spend Limit</p>
                              <span className="t-bold">
                                <span style={{ fontSize: 18 }}>
                                  {
                                    this.props.SubscriptionInfo.SubscriptionData
                                      .currencycode
                                  }{" "}
                                  {this.state.spendlimit}
                                </span>{" "}
                                <span className="input-label">/month</span>
                              </span>
                            </div>
                            <div className="floatright margin-top-10">
                              <CircularProgress
                                className="pro"
                                variant="static"
                                value={getValue(
                                  this.state.spendlimit,
                                  this.state.compensatedamount,
                                )}
                              />
                              <div>
                                {
                                  this.props.SubscriptionInfo.SubscriptionData
                                    .currencycode
                                }{" "}
                                {this.state.compensatedamount}
                              </div>
                            </div>
                          </Paper>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          sm={10}
                          className="padding-right-24 padding-bottom-24"
                        >
                          <div className="margin-bottom-8">
                            <span className="icon-with-label">
                              <img src={expenseIcon} alt="" height="16" />
                            </span>
                            <span className="icon-label">Expenses</span>
                          </div>
                          <Paper
                            className="padding16"
                            style={{
                              height: 80,
                              // background: dateallow && selected < today && "#f7f8f8",
                            }}
                          >
                            <div className="floatleft">
                              <p className="input-label">Pending approval</p>
                              <span className="t-bold">
                                {this.state.pendingclaimrequest} Expenses
                              </span>
                            </div>
                            <div className="floatright">
                              <p className="input-label">Saved for later</p>
                              <span className="t-bold">0 Scans</span>
                            </div>
                            <div className="clear-float">
                              {advanceRequest &&
                                advanceRequest.permissions.editable && (
                                  <Button
                                    color="primary"
                                    variant="contained"
                                    // className={
                                    //   dateallow && selected < today
                                    //     ? claimPolicy &&
                                    //       !claimPolicy.isallowedadvance
                                    //       ? "btn-primary-sm-grey margin-top-10"
                                    //       : "btn-primary-sm-grey margin-top-10"
                                    //     : claimPolicy &&
                                    //       !claimPolicy.isallowedadvance
                                    //     ? "btn-primary-sm-grey margin-top-10"
                                    //     : "light-blue-btn margin-top-10"
                                    // }
                                    className={
                                      dateallow &&
                                      selected < today &&
                                      claimPolicy &&
                                      !claimPolicy.isallowedadvance
                                        ? "btn-primary-sm-grey margin-top-10"
                                        : "light-blue-btn margin-top-10"
                                    }
                                    // disabled={
                                    //   dateallow && selected < today
                                    //     ? claimPolicy &&
                                    //       !claimPolicy.isallowedadvance
                                    //       ? true
                                    //       : true
                                    //     : claimPolicy &&
                                    //       !claimPolicy.isallowedadvance
                                    //     ? true
                                    //     : false
                                    // }
                                    disabled={
                                      dateallow &&
                                      selected < today &&
                                      claimPolicy &&
                                      !claimPolicy.isallowedadvance
                                        ? true
                                        : false
                                    }
                                    style={{
                                      width: 128,
                                      textTransform: "initial",
                                      padding: 5,
                                    }}
                                    onClick={() =>
                                      this.toggleDrawer({
                                        drawerStatus: true,
                                        reqType: "advanced",
                                      })
                                    }
                                  >
                                    Advance
                                  </Button>
                                )}
                              {expenseRequest &&
                                expenseRequest.permissions.editable && (
                                  <Button
                                    color="primary"
                                    variant="contained"
                                    // className={c ? "btn-primary-sm-grey margin-top-10" : "light-blue-btn margin-top-10"}
                                    className={"light-blue-btn margin-top-10"}
                                    style={{
                                      width: 128,
                                      textTransform: "initial",
                                      padding: 5,
                                      float: "right",
                                    }}
                                    // disabled={c}
                                    onClick={() =>
                                      this.toggleDrawer({
                                        drawerStatus: true,
                                        reqType: "claim",
                                      })
                                    }
                                  >
                                    Claim
                                  </Button>
                                )}
                            </div>
                          </Paper>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={12}
                          sm={12}
                          style={{ paddingRight: 24 }}
                        >
                          <div className="margin-bottom-8">
                            <span className="icon-with-label">
                              <img src={walletIcon} alt="" height="16" />
                            </span>
                            <span className="icon-label">Expense Book</span>
                          </div>
                          <Paper
                            className="padding16"
                            style={{ textAlign: "center" }}
                          >
                            <div
                              className={
                                this.state.chartdataValue.length > 0
                                  ? "expense-chart"
                                  : "expense-nodata-outer"
                              }
                            >
                              {this.state.chartdataValue.length > 0 ? (
                                <Doughnut
                                  data={{
                                    labels: this.state.chartdataLabels,
                                    datasets: [
                                      {
                                        label: "Expense book",
                                        data: this.state.chartdataValue,
                                        backgroundColor: [
                                          "#f7b596",
                                          "#b596f7",
                                          "#f7dc96",
                                          "#96acf7",
                                          "#96f7df",
                                          "#f7dc96",
                                          "#d0f796",
                                          "#e0f7fa",
                                          "#eceff1",
                                          "#efebe9",
                                          "#d7ccc8",
                                          "#cfd8dc",
                                          "#e3f2fd",
                                          "#fff9c4",
                                          "#b2dfdb",
                                          "#c8e6c9",
                                          "#e0e0e0",
                                          "#ffe0b2",
                                          "#f3e5f5",
                                        ],
                                      },
                                    ],
                                  }}
                                  width="150px"
                                  height="100px"
                                  options={{
                                    rotation: 100,
                                    animation: {
                                      animateRotate: true,
                                    },
                                    tooltips: {
                                      footerFontSize: 24,
                                      titleFontSize: 24,
                                      bodyFontSize: 24,
                                    },
                                    title: {
                                      display: true,
                                      text: "Expense book",
                                      position: "top",
                                      fontSize: 22,
                                    },
                                    legend: {
                                      display: true,
                                      position: "bottom",
                                      fullWidth: false,
                                      labels: {
                                        fontFamily: "Muli",
                                        fontSize: 24,
                                      },
                                    },
                                  }}
                                />
                              ) : (
                                <div className="text-align-center expense-nodata-inner">
                                  <img src={expensenodata} />
                                  <div className="small-dark">
                                    There were no expenses this month
                                  </div>
                                </div>
                              )}
                            </div>
                          </Paper>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={4} sm={2}>
                      <div className="margin-bottom-8">
                        <span className="icon-with-label">
                          <img src={expensePassbookIcon} alt="" height="16" />
                        </span>
                        <span className="icon-label">Expense Passbook</span>
                      </div>
                      <Paper className="padding16 expense-nodata-outer">
                        {this.state.expensebook.length > 0 ? (
                          this.state.expensebook.map((book) => (
                            <Grid
                              key="book"
                              container
                              className="passbook-item"
                            >
                              <Grid item xs={12} md={10} sm={12}>
                                <div className="floatleft margin-right-8">
                                  <img
                                    src={expensePassbookIcon}
                                    alt=""
                                    height="16"
                                  />
                                </div>
                                <div>
                                  <span className="inline-display margin-right-16">
                                    {
                                      this.props.SubscriptionInfo
                                        .SubscriptionData.currencycode
                                    }{" "}
                                    {book.compensatamount}
                                  </span>
                                  <span>{book.subcategoryname}</span>
                                  <span className="display-block input-label">
                                    {book.billdate &&
                                      getFormattedDate(book.billdate)}
                                  </span>
                                </div>
                              </Grid>
                              <Grid item xs={12} md={2} sm={12}>
                                <div>
                                  <span className="floatleft margin-right-8">
                                    {book.attachment && book.attachment.length}
                                  </span>
                                  <span>
                                    <img
                                      src={attachmentIcon}
                                      height="16"
                                      className="vertical-middle"
                                    />
                                  </span>
                                </div>
                              </Grid>
                            </Grid>
                          ))
                        ) : (
                          <div className="text-align-center expense-nodata-inner1">
                            <img src={expensenodata} />
                            <div className="small-dark">
                              There were no expenses this month
                            </div>
                          </div>
                        )}
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
            {(claimerror || (noDataAvailable && employeeid)) && (
              <Grid
                container
                style={{ height: "88vh" }}
                className="position-rel"
              >
                <Grid item xs={12} md={12} sm={12}>
                  <DefaultComp
                    heading="There is no expense policy assigned yet!"
                    subheading="You can only view expense logs after a policy has been assigned."
                    imageSrc={emptylist}
                  />
                </Grid>
              </Grid>
            )}
            <Drawer
              anchor="right"
              open={this.state.drawerStatus}
              onClose={() =>
                this.toggleDrawer({ drawerStatus: false, reqType: "" })
              }
              classes={{
                paper: "drawer-main",
              }}
            >
              {reqType == "claim" && dataReceived && (
                <ClaimRequest
                  {...this.state}
                  {...this.props}
                  toggleDrawer={this.toggleDrawer}
                />
              )}
              {reqType == "advanced" && (
                <AdvancedRequest
                  {...this.state}
                  {...this.props}
                  toggleDrawer={this.toggleDrawer}
                />
              )}
            </Drawer>
          </div>
        )}
      </div>
    );
  }
}

ExpenseDahsboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setDynamicForm }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles()(withSnackbar(ExpenseDahsboard)));
